<template>
  <v-card color="black" class="ma-0">
    <v-toolbar dark flat color="black" class="pl-2 pt-1 elevation-0">
      <v-btn text @click="close" icon><v-icon>close</v-icon></v-btn>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text class="pa-1">
      <video v-if="type === 'video'" :src="url" ref="video" controls :controlsList="!isAdmin ? 'nodownload' : ''" autoplay style="width: 100%; height: 500px;" ></video>
      <v-img v-if="type === 'image'" :src="url" max-height="600" contain></v-img>
      <audio v-if="type === 'audio'" :src="url" ref="audio" controls :controlsList="!isAdmin ? 'nodownload' : ''" autoplay style="width: 100%"></audio>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MediaPreviewer',
  props: {
    url: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  methods: {
    close () {
      if (this.type === 'audio') {
        const elAudio = this.$refs.audio
        if (elAudio !== undefined) {
          elAudio.pause()
          elAudio.currentTime = 0
        } 
      } else if (this.type === 'video') {
        const elVideo = this.$refs.video
        if (elVideo !== undefined) {
           elVideo.pause()
        }
      }

      this.$emit('close')
    }
  }
}
</script>
